import React, { FC, Fragment } from 'react';
import { useQuery } from '@apollo/client';
import { list } from '../../../graph/rooms';
import MultiSelectInput from '@/se/components/inputs/MultiSelectInput';

const RoomMultiSelectInputAll: FC<any> = ({ value, onChange }) => {
  const { data, loading } = useQuery(list);

  if (loading) return null;

  const options = (data?.rooms || [])?.map(e => ({
    label: e.name,
    value: e.id,
  }));

  const transformedValue = options.filter(e => (value || []).includes(e.value));

  return (
    <Fragment>
      <MultiSelectInput
        name={'or-rooms-select'}
        options={options}
        onChange={updated => {
          onChange(updated?.map(e => e.value));
        }}
        value={transformedValue}
        loading={false}
        disabled={false}
      />
    </Fragment>
  );
};

export default RoomMultiSelectInputAll;
